import { Component, Input } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 's-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  // @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() disabled = false;
  @Input() active = false;
  @Input() color: 'primary' | 'secondary' | 'light' = 'primary';
  @Input() size: 'lg' | 'md' | 'sm' = 'md';
  @Input() minWidth: string | undefined = undefined;
  @Input() type: 'filled' | 'outlined' = 'filled';

  @Output() customClick = new EventEmitter<Event>();

  get btnClasses(): string {
    return [
      //
      this.color ? `btn-${this.color}` : '',
      this.size ? `btn-${this.size}` : '',
      this.active ? `btn-active` : '',
      // this.type ? `btn--${this.type}` : '',
    ].join(' ');
  }

  get styles(): string {
    return [this.minWidth ? `min-width: ${this.minWidth}` : ''].join('');
  }

  handleClick(event: Event): void {
    event.stopPropagation();
    this.customClick.emit(event);
  }
}
